import { Check } from "lucide-react";

/** Trailing checkmark on the selected option of a task property picker. */
// `!` beats CommandItem's `[&_svg]:size-4`.
export function SelectedCheck() {
  return <Check strokeWidth={3} className="ml-auto size-3.5! shrink-0 opacity-60" />;
}
